module.exports = (topicId, postId, doesLike, callback) => {
  const xhr = new window.XMLHttpRequest()
  var url = '/member/like?like=' + doesLike + (topicId ? '&tid=' + topicId : '')
  xhr.onreadystatechange = (evt) => {
    if (xhr.readyState === 4) {
      if (callback) callback()
    }
  }
  xhr.open('POST', url, true)
  xhr.setRequestHeader('Content-Type', 'application/json')
  xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest')
  xhr.send(JSON.stringify({
    liked: !!doesLike,
    postid: parseInt(postId, 10)
  }))
  return xhr
}
